export default {
  recipes: [],
  recipeOptions: [
    "all",
    "breakfast",
    "lunch",
    "dinner",
    "new",
    "favorites",
    "super healthy",
    "cheating",
  ],
  reganAndRaeFavorites: [],
  apiCallsInProgress: 0,
  newRecipe: {
    _id: null,
    title: "",
    slug: "",
    keywords: [],
    recipeOwner: "",
    category: [],
    difficulty: "",
    steps: [],
    prepTime: "",
    cookTime: "",
    notes: "",
    ingredients: [],
  },
  user: { signedIn: false, displayName: null, email: null },
  profile: {
    _id: null,
    settings: {
      theme: "light",
    },
    favorites: [],
    bookmarked: [],
    following: [],
    friends: [],
    colorTheme: "",
    notes: "String",
    score: 0,
    description: "String",
  },
  viewingUser: {},
};
